import React from "react";


import BottombarMain from './bottombar.main.component';
import BottombarProperty from './bottombar.property.component';
import BottombarModules from './bottombar.modules.component';
import BottombarFinishes from './bottombar.finishes.component';
import BottombarQuote from './bottombar.quote.component';


import arrowBtn from '../../../assets/icons/Icon_Show-Hide.svg'
const Floors = require("../../../data/floor.data");
const PropertyType = require("../../../data/property.type.data");
const AllModules = require("../../../data/module.data");
const ModulesConfig = require("../../../data/configs.data");
const AllFinishes = require("../../../data/finishes.data");

interface Props {
  showIntro: boolean,
  isCollapsed: boolean;
  propertyType: any;
  module1: any;
  module2: any;
  module3: any;
  module4: any;
  finishesRail: any;
  finishesFloor: any;
  finishesMeson: any;
  finishesWoodwork: any;
  modulesCompleted: boolean;
  bottomMenu: string;
  setModule1: (value: any) => void;
  setModule2: (value: any) => void;
  setModule3: (value: any) => void;
  setModule4: (value: any) => void;
  setFinishesRail: (value: any) => void;
  setFinishesFloor: (value: any) => void;
  setFinishesMeson: (value: any) => void;
  setFinishesWoodwork: (value: any) => void;
  setIsCollapsed: (boolean: any) => void;
  setModulesCompleted: (boolean: any) => void;
  setBottomMenu: (value: string) => void;


  audioMute: boolean;
  property: any;
  floor: any;
  showQuote: boolean;
  totalPrice: string;
  showAlternative: string;
  setFloor: (value: any) => void;
  setProperty: (value: any) => void;
  setPropertyType: (value: any) => void;
  setShowQuote: (value: boolean) => void;
  setAudioMute: (value: boolean) => void;
  setShowAlternative: (value: any) => void;
}

const Bottombar: React.FC<Props> = ({ showIntro, isCollapsed, module1, module2, module3, module4, finishesRail, finishesFloor, finishesMeson, finishesWoodwork, propertyType, modulesCompleted, bottomMenu, showAlternative, setIsCollapsed, setModule1, setModule2, setModule3, setModule4, setFinishesRail, setFinishesFloor, setFinishesMeson, setFinishesWoodwork, setModulesCompleted, setBottomMenu, audioMute, property, floor, showQuote, totalPrice, setFloor, setProperty, setPropertyType, setAudioMute, setShowQuote, setShowAlternative }) => {

  /*********REPLACE FOR TOPBAR********/
  const [propertyOptions, setPropertyOptions] = React.useState<any>({});

  React.useEffect(() => {
    setFloor(Object.keys(Floors.Data)[0]);
  }, [setFloor]);
  React.useEffect(() => {
    setPropertyType(PropertyType.Data[0]);
  }, [setPropertyType]);

  React.useEffect(() => {
    if(floor){
      const options = Floors.Data[floor];
      setPropertyOptions(options);
      const firstOption = Object.keys(options)[0];
      setProperty(options[firstOption]);
    }
  }, [floor, setProperty]);

  const setLocalProperty = (value: string) => {
    if(!propertyOptions)
      return;
    const property = propertyOptions[value];
    if(!property)
      return;
    setProperty(property);
  };

  /*********REPLACE FOR SIDEBAR-MODULES********/
  const [activeGroup, setActiveGroup] = React.useState(0);
  const [modulesList, setModulesList] = React.useState<any>([]);
  const [isAlternative, setIsAlternative] = React.useState(false);
  const [availableTypologies, setAvailableTypologies] = React.useState([]);

  React.useEffect(() => {
    if(propertyType.id){
      const modulesProperty = AllModules.Data[propertyType.id];
      setModule1(null);
      setModule2(null);
      setModule3(null);
      setModule4(null);
      setModulesList(modulesProperty);
    }
  }, [propertyType, setModule1, setModule2, setModule3, setModule4]);

  React.useEffect(() => {
    let completed = true;
    if(modulesList.length === 0)
      return;
    if(modulesList.length > 0){
      completed = completed && (module1 !== null)
    }
    if(modulesList.length > 1){
      completed = completed && (module2 !== null)
    }
    if(modulesList.length > 2){
      completed = completed && (module3 !== null)
    }
    if(modulesList.length > 3){
      completed = completed && (module4 !== null)
    }
    setModulesCompleted(completed);

    let isMorphy = false;
    if(module2 !== null && module2.id === "murphy"){
      isMorphy = true;
    }
    if(module3 !== null && module3.id === "murphy"){
      isMorphy = true;
    }
    setIsAlternative(isMorphy)
    if(isMorphy)
      setShowAlternative("Murphy");
    else
      setShowAlternative("");

  }, [module1, module2, module3, module4, propertyType, modulesList, setModulesCompleted, setShowAlternative]);

  React.useEffect(() => {
    if(modulesList.length === 0)
      return;

    const config = ModulesConfig.Data[propertyType.id];
    let updateConfigs: any = [];
    for(const typology in config){
      updateConfigs.push(config[typology]);
    }

    if(modulesList.length > 1 && module1 !== null){
      const config: any = [];
      for(const localConfig of updateConfigs){
        if(module1.id.toLowerCase().includes(localConfig.module1) ){
          config.push(localConfig);
        }
      }
      updateConfigs = config;
    }
    if(modulesList.length > 2 && module2 !== null){
      const config: any = [];
      for(const localConfig of updateConfigs){
        if(module2.id.toLowerCase().includes(localConfig.module2) ){
          config.push(localConfig);
        }
      }
      updateConfigs = config;
    }
    if(modulesList.length > 3 && module3 !== null){
      const config: any = [];
      for(const localConfig of updateConfigs){
        if(module3.id.toLowerCase().includes(localConfig.module3) ){
          config.push(localConfig);
        }
      }
      updateConfigs = config;
    }
    if(modulesList.length > 4 && module4 !== null){
      const config: any = [];
      for(const localConfig of updateConfigs){
        if(module4.id.toLowerCase().includes(localConfig.module4) ){
          config.push(localConfig);
        }
      }
      updateConfigs = config;
    }
    setAvailableTypologies(updateConfigs);
  }, [module1, module2, module3, module4, propertyType, modulesList, setModulesCompleted, setShowAlternative]);



  /*********REPLACE FOR SIDEBAR-FINISHES********/
  const [finishesList, setFinishesList] = React.useState<any>([]);
  React.useEffect(() => {
    if(propertyType.id){
      const finishesProperty = AllFinishes.Data[propertyType.id];
      for (const finishes of finishesProperty){
        const category = finishes.category;
        if(category === 'finishesRail'){
          setFinishesRail(finishes.options[0]);
        }else if(category === 'finishesWoodwork'){
          setFinishesWoodwork(finishes.options[0]);
        }else if(category === 'finishesMeson'){
          setFinishesMeson(finishes.options[0]);
        }else if(category === 'finishesFloor'){
          setFinishesFloor(finishes.options[0]);
        }
      }
      setFinishesList(finishesProperty);
    }
  }, [propertyType, setFinishesRail, setFinishesWoodwork, setFinishesMeson, setFinishesFloor]);

  /*********MINOR FIXES********/
  const setLocalShowQuote = (value: boolean) => {
    setShowQuote(value);
    setIsCollapsed(true);
  }

  React.useEffect(() => {
    if(showIntro === false){
      setIsCollapsed(false);
    }
  }, [showIntro, setIsCollapsed]);

  return (
    <div className={`bottombar-full-container ${isCollapsed ? 'hidden':''} ${(isCollapsed && bottomMenu !== 'Apartamento') ? 'hiddenhigh':''}`}>
      <div className={`bottombar-collapse-btn ${isCollapsed ? 'collapsed':''}`} onClick={() => {setIsCollapsed(!isCollapsed)}}>
        <img src={arrowBtn} alt=''/>
      </div>

      <div className={`bottombar-menu-title`}/>
      <div className={`bottombar-menu-container`}>
        {bottomMenu === 'Apartamento' && <BottombarProperty propertyType={propertyType} setPropertyType={setPropertyType}/>}
        
        {bottomMenu === 'Mobiliario' && <BottombarModules propertyType={propertyType} module1={module1} module2={module2} module3={module3} module4={module4} modulesCompleted={modulesCompleted} showAlternative={showAlternative} setShowAlternative={setShowAlternative} setModule1={setModule1} setModule2={setModule2} setModule3={setModule3} setModule4={setModule4} setModulesCompleted={setModulesCompleted}
        activeGroup={activeGroup} modulesList={modulesList} isAlternative={isAlternative} availableTypologies={availableTypologies} setActiveGroup={setActiveGroup} setModulesList={setModulesList} setIsAlternative={setIsAlternative} setAvailableTypologies={setAvailableTypologies}/>}
        
        {bottomMenu === 'Acabados' && <BottombarFinishes propertyType={propertyType} finishesRail={finishesRail} finishesFloor={finishesFloor} finishesMeson={finishesMeson} finishesWoodwork={finishesWoodwork} setFinishesRail={setFinishesRail} setFinishesFloor={setFinishesFloor} setFinishesMeson={setFinishesMeson} setFinishesWoodwork={setFinishesWoodwork} finishesList={finishesList} setFinishesList={setFinishesList}/>}

        {bottomMenu === 'Cotizacion' && <BottombarQuote totalPrice={totalPrice} modulesCompleted={modulesCompleted} propertyOptions={propertyOptions} setFloor={setFloor} setProperty={setLocalProperty} setShowQuote={setLocalShowQuote}/>}
        
      </div>
      <BottombarMain menu={bottomMenu} setMenu={setBottomMenu}/>
    </div>
  );
};

export default Bottombar;
